import React, { FC } from 'react';

import { Button, ButtonProps } from '@lglp/components';
import { useTranslation } from 'react-i18next';

import { HEADER } from 'translations';

import CloseIcon from '../../../../components/icons/CloseIcon';
import MenuIcon from '../../../../components/icons/MenuIcon';
import { useMobileContext } from './MobileContext';
import styles from './OpenCloseMenu.module.scss';

export const OpenCloseButtonMenu: FC<ButtonProps> = ({
  className,
  ...rest
}) => {
  const { opened, toggleMenu } = useMobileContext();
  const { t } = useTranslation();

  return (
    <Button
      className={[
        styles.openCloseMenu,
        styles.buttonAction,
        opened && styles.opened,
        className,
      ]}
      onClick={() => {
        toggleMenu(!opened);
      }}
      {...rest}
    >
      {opened ? <CloseIcon /> : <MenuIcon />}
      <Button.Label className={styles.buttonLabel}>
        {t(opened ? HEADER.MENU_CLOSE : HEADER.MENU_OPEN)}
      </Button.Label>
    </Button>
  );
};
